<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Cortesias | Criação" @back="router.push({ name: 'list-complimentary-tickets'})" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-complimentary-ticket v-model="model" @submit="($model: StorePayload, clearFields: () => Promise<void>) => submit($model, clearFields)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import ComplimentaryTicketService from '@/services/ComplimentaryTicketService'
import { type StorePayload } from '@/services/ComplimentaryTicketService'
import FormComplimentaryTicket from './form-complimentary-ticket.vue'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { router } from '@/router'

const loader = useLoader()

const snackbar = useSnackBar()

const model = ref<StorePayload>({ ticket_types: [] } as unknown as StorePayload)

async function submit(model: StorePayload, clearFields: () => Promise<void>) {
  loader.increment()
  try {
    await (new ComplimentaryTicketService()).store(model)

    snackbar.show(
      'Cortesia criada com sucesso',
      'success',
    )

    // The creation of complimentary tickets is an operation that happens dozens of times in a row, so avoiding
    // page redirect and just cleaning the fields so a new ticket can be created provides a better UX.
    await clearFields()
  } finally {
    loader.decrement()
  }
}
</script>
